import { useContext, useState, useCallback, useRef } from 'react';
import {
  IOTP, IRecoverPassword, IRecoveryForm, IPasswordForm,
  IPasswordVisibilityOption, FORM_STEP, OTP_VALIDITY_IN_MS,
  MODAL_KEY,
} from '../constant';
import { RecoverPasswordProvider } from '../contexts';
import { POPUP_TYPE } from '../../subComponents/commonModal';
import { CommonPortalContext } from '../../../contexts/commonPortal';
import { IPopup } from '../../../constants/commonPortal.constant';

const RecoverPasswordController = (props) => {
  const {
    recoverPassword = IRecoverPassword(),
    history,

    component: Component,

    SendPasswordRecoveryOTP: sendOTP = async (data = {}) => ({}),
    ValidatePasswordRecoveryOTP: validateOTP = async (data = {}) => ({}),
    ResetPasswordUsingPasswordRecoveryOTP: recoverPasswordAction = async (data = {}) => ({}),
    ClearRecoverPassword: clearRecoverPassword = (data = {}) => {},
  } = props;

  const { handler: { handleSnackbarClose, handleSnackbarOpen } } = useContext(CommonPortalContext);

  const [modalCollection, setModalCollection] = useState(new Map());
  const [recoverForm, setRecoverForm] = useState(IRecoveryForm());
  const [passwordForm, setPasswordForm] = useState(IPasswordForm());
  const [visibilityOption, setVisibilityOption] = useState(IPasswordVisibilityOption());
  const [otp, setOTP] = useState(IOTP());
  const [formStep, setFormStep] = useState(FORM_STEP.STEP_1);
  const otpExpiryTime = useRef(0);

  const handleModalOpen = useCallback(({
    key = '',
    modal = {},
  }) => {
    const collection = new Map(modalCollection);
    collection.set(key, modal);
    setModalCollection(collection);
  }, [modalCollection]);

  const handleModalClose = useCallback(({
    key,
  }) => {
    const collection = new Map(modalCollection);
    collection.delete(key);
    setModalCollection(collection);
  }, [modalCollection]);

  const handleMultipleModalClose = useCallback(({
    keys = [],
  }) => {
    const collection = new Map(modalCollection);
    keys.forEach((key) => {
      collection.delete(key);
    });
    setModalCollection(collection);
  }, [modalCollection]);

  const handleSendOTP = async () => {
    try {
      // clear the otp
      setOTP(IOTP());

      let isCodeSent = false;
      const { data, status } = await sendOTP(recoverForm);
      if (status === 200) {
        const {
          Data: {
            Alias: alias,
            CompanyId: companyId,
            PatientPhone: phone,
            PeopleId: peopleId,
            IsCodeSent,
          },
        } = data;

        setRecoverForm({
          ...recoverForm,
          alias,
          peopleId,
          phone,
          companyId,
        });

        otpExpiryTime.current = new Date().getTime() + OTP_VALIDITY_IN_MS;

        // skip nested if condition
        isCodeSent = IsCodeSent;
      }

      if (status !== 200) {
        const {
          Message: message = 'Could not send OTP, please try again.',
          Status: title = 'Error',
        } = data;

        handleSnackbarOpen(IPopup({
          open: true,
          title,
          type: POPUP_TYPE.ERROR,
          message,
          onOk: handleSnackbarClose,
        }));
      }

      if (isCodeSent) {
        handleModalOpen({ key: MODAL_KEY.CONFIRM_OTP, modal: {} });
      }
    } catch (e) {
      // Error handling spinnet if any required
    }
  };

  return (
    <RecoverPasswordProvider
      value={{
        modalCollection,
        setModalCollection,

        recoverPassword,

        recoverForm,
        setRecoverForm,

        passwordForm,
        setPasswordForm,

        visibilityOption,
        setVisibilityOption,

        formStep,
        setFormStep,

        otp,
        setOTP,

        otpExpiryTime,

        history,

        handler: {
          handleModalOpen,
          handleModalClose,
          handleMultipleModalClose,
          handleSendOTP,
        },

        action: {
          sendOTP,
          validateOTP,
          recoverPassword: recoverPasswordAction,
          clearRecoverPassword,
        },
      }}
    >
      <Component {...props} />
    </RecoverPasswordProvider>
  );
};

export const RecoverPasswordControllerHOC = (Component) => (props) => (
  <RecoverPasswordController component={Component} {...props} />
);

export default RecoverPasswordControllerHOC;
